export default {
  apiKey: "AIzaSyD2_Xym3JwRS6SFqdw8d2aNg0z3LRwz7ss",
  authDomain: "fieldservices-f2133.firebaseapp.com",
  projectId: "fieldservices-f2133",
  storageBucket: "fieldservices-f2133.appspot.com",
  messagingSenderId: "620547800728",
  appId: "1:620547800728:web:455de9c185e053ec305aed"
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js